import { render, staticRenderFns } from "./registerForm.vue?vue&type=template&id=2c0b5f8d&scoped=true&"
import script from "./registerForm.vue?vue&type=script&lang=js&"
export * from "./registerForm.vue?vue&type=script&lang=js&"
import style0 from "./registerForm.vue?vue&type=style&index=0&id=2c0b5f8d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0b5f8d",
  null
  
)

/* custom blocks */
import block0 from "./registerForm.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports